module.exports = __webpack_public_path__ + "static/img/cert6.8b85fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert6.png
// module id = M84R
// module chunks = 1